<script setup lang="ts">
import { IconListBullets, IconMap } from '@icons';
import Button from '@components/Button.vue';
import Icon from '@components/Icon.vue';
import { useSearchStore } from '@stores/useSearchStore.ts';
import { storeToRefs } from 'pinia';
import { trans } from '@tools/translation.ts';
import { useScreensizeStore } from '@stores/useScreensizeStore.ts';

const searchStore = useSearchStore();
const { mapIsVisible } = storeToRefs(searchStore);
const { openMap, closeMap } = searchStore;

const { isMobileOrTablet } = storeToRefs(useScreensizeStore());

const toggleMap = (): void => {
  mapIsVisible.value ? closeMap() : openMap();
};
</script>

<template>
  <div
    :class="[
      'fixed bottom-1 z-110',
      'flex items-center justify-center gap-x-4',
      !isMobileOrTablet && mapIsVisible ? 'left-[369px]' : 'left-1/2 -translate-x-1/2',
      isMobileOrTablet && !mapIsVisible ? 'bottom-[72px]' : 'bottom-6',
    ]"
  >
    <!-- @todo : implement alert button, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-10563 -->

    <Button
      v-if="isMobileOrTablet"
      variant="white"
      :class="[
        '!flex items-center justify-center gap-x-2',
        '!h-12 !w-fit bg-white shadow-md',
        '!text-black',
      ]"
      @click="toggleMap"
    >
      <span>
        {{ mapIsVisible ? trans('mobile.view.option.list') : trans('global.map') }}
      </span>

      <Icon
        :svg="mapIsVisible ? IconListBullets : IconMap"
        width="24"
        height="24"
      />
    </Button>
  </div>
</template>
